module.exports = __webpack_public_path__ + "static/media/crime.ddb5e46a.svg";